import { render, staticRenderFns } from "./examTaskDialog.vue?vue&type=template&id=2095e7bc"
import script from "./examTaskDialog.vue?vue&type=script&lang=js"
export * from "./examTaskDialog.vue?vue&type=script&lang=js"
import style0 from "./examTaskDialog.vue?vue&type=style&index=0&id=2095e7bc&prod&lang=scss&rel=stylesheet%2Fscss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports